export const blockIconsHomeToolsLadderNew = (
	<span className='material-symbols-outlined'>tools_ladder</span>
);
